// extracted by mini-css-extract-plugin
var _1 = "WeekDay-moduleWeekDay__mvlIm Day-moduleDay__tTwxX";
export { _1 as "WeekDay" }
